/* globals confirm, console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    ModalDialog = require('./modalDialog'),
    VacanciesList = require('./vacanciesList'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'units-list-item'
    },
    childViewEvents: {
        'vacancy:added': 'onVacancyCountChanged',
        'vacancy:destroyed': 'onVacancyCountChanged',
        // 'vacancy:sync': 'onVacancySync'
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);}
    },
    events: {
        'click button': 'onClickButton',
        'input input': 'onInputSelectChange',
        'change select': 'onInputSelectChange'
    },
    regions: {
        vacanciesList: 'div[name=vacanciesList]'
    },
    tagName: 'div',
    template: templates.unitsListItem,
    ui: {
        unitForm: 'form[name=unit]'
    },
    initialize: function () {
        this.create = !this.model.id;
        this.templateContext = _.bind(function () {
            if (!this.create) {
                return {
                    programId: this.options.programId,
                    editable: this.options.hasAdminAccess
                };
            }
            return {
                programId: this.options.programId,
                editable: this.options.hasAdminAccess,
                create: this.create,
                name: 'New Unit Type',
                unitStatusTypeId: -1,
                unitCategoryTypeId: -1,
                bathroomTypeId: -1,
                accessibilityTypeIds: []
            };
        }, this);
        this.listenTo(this.model, 'sync', _.bind(function () {
            this.create = false;
            this.render();
        }, this));
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action,
            section = event.currentTarget.dataset.section,
            mode = function (mode, section) {
                jQuery('div[name=display], button[name=edit]', section).toggleClass('hidden', mode === 'edit');
                jQuery('div[name=edit], button[name=save], button[name=delete], button[name=cancel]', section).toggleClass('hidden', mode === 'display');
            },
            processSection = _.bind(function (action) {
                let serializedArray,
                    updateModel = false,
                    multipleIdProperties;
                const ui = this.ui;
                if (!this.editInProgress) {
                    // callback(null);
                    return;
                }
                // serializedArray = this.ui.unitForm.serializeArray();
                // if (JSON.stringify(this.priorSerializedArray) === JSON.stringify(serializedArray)) {
                //     // presumably results from serializeArray are always the same if form contents haven't changed
                //     // if that turns out to not be the case then we can switch to lodash.isEqual (and definitely not split and sort stringified results...)
                //     // for 1000 iterations - JSON.stringify:8.912ms, lodash.isEqual:30.450ms,  JSON.stringify.split('').sort():140.744ms
                //     return;
                // }
                switch (action) {
                    case 'cancel':
                        this.render(); // restores any changes to the form
                        break;
                    case 'save':
                        updateModel = true;
                        break;
                    default:
                        // updateModel = confirm('Changes have not been saved.\nClick OK to save before continuing.\nClick Cancel to continue without saving.');
                        break;
                }
                if (updateModel) {
                    serializedArray = this.ui.unitForm.serializeArray();
                    this.model.update(serializedArray);
                    this.trigger('program.updated');
                }
                this.editInProgress = false;
            }, this);
        let bubble = false;
        switch (action) {
            case 'cancel':
                if (!this.create) {
                    processSection(action);
                    mode('display', jQuery(event.currentTarget).closest('div[name=' + section + '] > div')); // immediate div to not grab embedded vacancy list
                } else {
                    this.model.destroy();
                    this.destroy();
                }
                this.trigger('edit:end');
                break;
            case 'delete':
                this.modalDialog = new ModalDialog({template: templates.delete, templateContext: {type: 'unitLabel', name: this.model.attributes.name}, modalModal: true});
                this.modalDialog.on('modalDialog:delete', _.bind(function (o) {
                    this.model.destroy();
                    this.model = null;
                }, this));
                this.trigger('edit:end');
                break;
            case 'edit':
                this.priorSerializedArray = this.ui.unitForm.serializeArray();
                mode('edit', jQuery(event.currentTarget).closest('div[name=' + section + '] > div'));
                this.trigger('edit:start');
                break;
            case 'save':
                if (this.ui.unitForm[0].checkValidity()) {
                    processSection(action);
                    mode('display', jQuery(event.currentTarget).closest('div[name=' + section + '] > div'));
                    this.trigger('edit:end');
                } else {
                    this.ui.unitForm.toggleClass('was-validated', true);
                }
                break;
            default:
                console.log('unitsListItem.onClickButton - action:%s', action);
                break;
        }
        return false;
    },
    onEditInProgress: function () {
        if (!this.editInProgress) {
            this.$el.find('button[data-action=save]').attr('disabled', false);
            this.editInProgress = true;
        }
    },
    onInputSelectChange: function (event) {
        this.onEditInProgress();
    },
    onRender: function () {
        if (!this.create) {
            this.showChildView('vacanciesList', new VacanciesList({unitId: this.model.id, hasAdminAccess: this.options.hasAdminAccess}));
        }
    },
    // onVacancySync: function () {
    onVacancyCountChanged: function () {
        this.model.fetch();
        this.trigger('vacancy:countChanged');
    }
});
